import { useAuthContext } from '../contexts/AuthContext';
import type { Lang } from './types';

import AgpRecentMovementsTable_en from './Agp.RecentMovementsTable.en';
import AgpRecentMovementsTable_nl from './Agp.RecentMovementsTable.nl';
import AgpRecentMovementsTable_no from './Agp.RecentMovementsTable.no';
import AgpReleasesTable_en from './Agp.ReleasesTable.en';
import AgpReleasesTable_nl from './Agp.ReleasesTable.nl';
import AgpReleasesTable_no from './Agp.ReleasesTable.no';
import AgpStockByProductTable_en from './Agp.StockByProductTable.en';
import AgpStockByProductTable_nl from './Agp.StockByProductTable.nl';
import AgpStockByProductTable_no from './Agp.StockByProductTable.no';
import BatchGraphView_en from './BatchGraphView.en';
import BatchGraphView_nl from './BatchGraphView.nl';
import BatchGraphView_no from './BatchGraphView.no';
import CalendarWidget_en from './CalendarWidget.en';
import CalendarWidget_nl from './CalendarWidget.nl';
import CalendarWidget_no from './CalendarWidget.no';
import Cost_en from './Cost.en';
import Cost_nl from './Cost.nl';
import Cost_no from './Cost.no';
import CurrentStep_en from './CurrentStep.en';
import CurrentStep_nl from './CurrentStep.nl';
import CurrentStep_no from './CurrentStep.no';
import ExciseDuty_en from './ExciseDuty.en';
import ExciseDuty_nl from './ExciseDuty.nl';
import ExciseDuty_no from './ExciseDuty.no';
import Gravity_en from './Gravity.en';
import Gravity_nl from './Gravity.nl';
import Gravity_no from './Gravity.no';
import Home_en from './Home.en';
import Home_nl from './Home.nl';
import Home_no from './Home.no';
import Ingredients_en from './Ingredients.en';
import Ingredients_nl from './Ingredients.nl';
import Ingredients_no from './Ingredients.no';
import ISpindelWidget_en from './ISpindelWidget.en';
import ISpindelWidget_nl from './ISpindelWidget.nl';
import ISpindelWidget_no from './ISpindelWidget.no';
import LanguageSelector_en from './LanguageSelector.en';
import LanguageSelector_nl from './LanguageSelector.nl';
import LanguageSelector_no from './LanguageSelector.no';
import NextStepsWidget_en from './NextStepsWidget.en';
import NextStepsWidget_nl from './NextStepsWidget.nl';
import NextStepsWidget_no from './NextStepsWidget.no';
import Sidebar_en from './Sidebar.en';
import Sidebar_nl from './Sidebar.nl';
import Sidebar_no from './Sidebar.no';
import Steps_en from './Steps.en';
import Steps_nl from './Steps.nl';
import Steps_no from './Steps.no';
import Taste_en from './Taste.en';
import Taste_nl from './Taste.nl';
import Taste_no from './Taste.no';
import TiltsWidget_en from './TiltsWidget.en';
import TiltsWidget_nl from './TiltsWidget.nl';
import TiltsWidget_no from './TiltsWidget.no';
import Tools_en from './Tools.en';
import Tools_nl from './Tools.nl';
import Tools_no from './Tools.no';
import Wiki_en from './Wiki.en';
import Wiki_nl from './Wiki.nl';
import Wiki_no from './Wiki.no';

const moduleTranslations = {
  Cost: { en: Cost_en, nl: Cost_nl, no: Cost_no },
  ExciseDuty: { en: ExciseDuty_en, nl: ExciseDuty_nl, no: ExciseDuty_no },
  Ingredients: { en: Ingredients_en, nl: Ingredients_nl, no: Ingredients_no },
  Steps: { en: Steps_en, nl: Steps_nl, no: Steps_no },
  Taste: { en: Taste_en, nl: Taste_nl, no: Taste_no },
  CurrentStep: { en: CurrentStep_en, nl: CurrentStep_nl, no: CurrentStep_no },
  Gravity: { en: Gravity_en, nl: Gravity_nl, no: Gravity_no },
  BatchGraphView: { en: BatchGraphView_en, nl: BatchGraphView_nl, no: BatchGraphView_no },
  'Agp.RecentMovementsTable': {
    en: AgpRecentMovementsTable_en,
    nl: AgpRecentMovementsTable_nl,
    no: AgpRecentMovementsTable_no,
  },
  'Agp.ReleasesTable': { en: AgpReleasesTable_en, nl: AgpReleasesTable_nl, no: AgpReleasesTable_no },
  'Agp.StockByProductTable': {
    en: AgpStockByProductTable_en,
    nl: AgpStockByProductTable_nl,
    no: AgpStockByProductTable_no,
  },
  LanguageSelector: { en: LanguageSelector_en, nl: LanguageSelector_nl, no: LanguageSelector_no },
  Home: { en: Home_en, nl: Home_nl, no: Home_no },
  NextStepsWidget: { en: NextStepsWidget_en, nl: NextStepsWidget_nl, no: NextStepsWidget_no },
  CalendarWidget: { en: CalendarWidget_en, nl: CalendarWidget_nl, no: CalendarWidget_no },
  TiltsWidget: { en: TiltsWidget_en, nl: TiltsWidget_nl, no: TiltsWidget_no },
  ISpindelWidget: { en: ISpindelWidget_en, nl: ISpindelWidget_nl, no: ISpindelWidget_no },
  Sidebar: { en: Sidebar_en, nl: Sidebar_nl, no: Sidebar_no },
  Tools: { en: Tools_en, nl: Tools_nl, no: Tools_no },
  Wiki: { en: Wiki_en, nl: Wiki_nl, no: Wiki_no },
} as const;

export function useModuleTranslation<M extends keyof typeof moduleTranslations>(
  module: M,
): (typeof moduleTranslations)[M][Lang] {
  const { language } = useAuthContext();
  const dict = moduleTranslations[module][language] || moduleTranslations[module].en;
  return dict;
}
